import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-15px); }
  100% { transform: translateY(0px); }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 100px 0;
  background: transparent; /* Picking up global gradient */
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1350px;
  padding: 0 40px;
  gap: 12px;
`;

export const Title = styled.h2`
  font-size: 56px;
  text-align: center;
  font-weight: 800;
  margin-top: 20px;
  color: #FFFFFF;
  letter-spacing: -0.02em;
  
  @media (max-width: 768px) {
    font-size: 36px;
  }
`;

export const Desc = styled.p`
  font-size: 19px;
  text-align: center;
  max-width: 650px;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 80px;
  line-height: 1.6;
`;

export const TechRail = styled.div`
  width: 100%;
  overflow: hidden;
  padding: 60px 0;
  position: relative;
  background: linear-gradient(90deg, transparent 0%, rgba(133, 76, 230, 0.05) 50%, transparent 100%);
`;

export const RailContent = styled.div`
  display: flex;
  gap: 40px;
  width: max-content;
  animation: ${scroll} 35s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

export const TechCard = styled.div`
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 20px;
  padding: 25px 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  min-width: 180px;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  backdrop-filter: blur(10px);

  &:hover {
    background: rgba(133, 76, 230, 0.08);
    border-color: #854CE6;
    transform: translateY(-12px) scale(1.05);
    box-shadow: 0 20px 40px rgba(133, 76, 230, 0.15);
  }
`;

export const IconImage = styled.img`
  width: 45px;
  height: 45px;
  object-fit: contain;
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.2));
`;

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  width: 100%;
  margin-top: 80px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const CategoryCard = styled.div`
  background: rgba(25, 25, 50, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.03);
  border-radius: 24px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  transition: all 0.4s ease;
  animation: ${float} 6s ease-in-out infinite;
  animation-delay: ${({ delay }) => delay || '0s'};

  &:hover {
    background: rgba(133, 76, 230, 0.05);
    border-color: rgba(133, 76, 230, 0.4);
    transform: scale(1.02);
  }
`;

export const CategoryTitle = styled.h4`
  font-size: 20px;
  font-weight: 700;
  color: #FFF;
  display: flex;
  align-items: center;
  gap: 12px;

  &::before {
    content: '';
    width: 4px;
    height: 20px;
    background: #854CE6;
    border-radius: 2px;
  }
`;

export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const Tag = styled.span`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 8px 16px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  cursor: default;
  display: flex;
  align-items: center;
  gap: 8px; /* Tight, professional spacing */

  img {
    margin-right: 2px; /* Extra nudge for optical centering */
  }

  &:hover {
    background: rgba(133, 76, 230, 0.2);
    color: #FFFFFF;
    border-color: #854CE6;
    transform: translateY(-3px);
  }
`;
